export function stripNullBytes(raw: string): string {
  return raw.replaceAll("\0", "");
}

export function stripNullBytesFromRecord(
  record: Record<string, string>
): Record<string, string> {
  return Object.fromEntries(
    Object.entries(record).map(([key, value]) => [
      stripNullBytes(key),
      stripNullBytes(value),
    ])
  );
}
